/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-20 17:24:45
 */
const rowsBig8 = {
    ballDistance: 31.6,
    diameter: 16.41,
    numRows: 8,
    yBonus: 15,
    ballProp: {
        mass: 1,
        densety: .9,
        friction: {
            x: .95,
            y: .98
        }
    },
    xps: {
        0: [316.097556434862, 317.23346234467454, 317.9236915729638, 317.91754727008043, 318.1658329000305, 365.9265563478446, 318.76612700932236, 318.225414399181],
        1: [317.8104086872175, 364.1239722359113, 317.2736219029089, 317.32056692019506, 318.14945863223136, 364.1812288347412, 317.57460453662003, 366.2313664924605],
        2: [318.2414289896738, 318.9349598611068, 364.3829902484083, 364.3583335093491, 317.88469633048896, 315.28107806787506, 366.49140791844576, 318.8449375520509],
        3: [316.23215586791133, 365.3208660075186, 316.3130854128258, 317.2708688903532, 317.7429728996715, 364.2392708980066, 316.78261762708615, 315.58563483410757],
        4: [363.4122181472941, 363.5729140040832, 316.5777642784063, 317.7511592890315, 365.61500685307954, 363.7787602661593, 316.6637779388656, 318.04507323500724],
        5: [316.83865165798386, 366.76596169501926, 363.8895865651224, 363.2463319985302, 364.83239385780576, 363.3660567484777, 366.9297086037174, 365.02360282996875],
        6: [314.9989535399075, 366.61921909785394, 366.46217947477464, 364.81418751190637, 363.6231754660703, 364.17302816411666, 363.6231117791345, 317.72389155960747],
        7: [364.26898240542744, 363.010509368975, 365.7822324457466, 366.1576078623707, 316.772701609891, 315.5100302093001, 363.39783156157193, 364.79607319275874],
        8: [315.5091430015873, 364.8818866227677, 365.8406235070656, 365.9021634496538, 364.68154969425757, 366.0825128888522, 364.7199248276154, 365.7205377940236],
        9: []
    }
};
export {rowsBig8 as default};
